import { loadImage } from 'mixtiles-web-common/services/imageLoader'
import { canvasToBlobUrl } from 'mixtiles-web-common/services/canvasService'

export async function downscaleImageFile(
  file: File,
  maxDimensionSize: number
): Promise<{
  file: File
  didDownscale: boolean
  width: number
  height: number
}> {
  const objectUrl = URL.createObjectURL(file)

  try {
    const img = await loadImage(objectUrl)

    const { width, height } = img
    const {
      width: newWidth,
      height: newHeight,
      didDownscale,
    } = getDownscaledDimensions(width, height, maxDimensionSize)

    if (!didDownscale) return { file, didDownscale: false, width, height }

    const canvas = document.createElement('canvas')
    canvas.width = newWidth
    canvas.height = newHeight
    const ctx = canvas.getContext('2d')

    if (!ctx) throw new Error('Failed to get canvas context')

    ctx.drawImage(img, 0, 0, newWidth, newHeight)

    const { blob, blobUrl } = await canvasToBlobUrl(canvas, 'image/jpeg', 0.8)
    URL.revokeObjectURL(blobUrl)

    return {
      file: new File([blob], file.name, {
        type: blob.type,
        lastModified: Date.now(),
      }),
      didDownscale: true,
      width: newWidth,
      height: newHeight,
    }
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}

export function getDownscaledDimensions(
  width: number,
  height: number,
  maxDimensionSize: number
): { width: number; height: number; didDownscale: boolean } {
  if (width <= maxDimensionSize && height <= maxDimensionSize)
    return { width, height, didDownscale: false }

  const aspectRatio = width / height

  if (width >= height) {
    return {
      width: maxDimensionSize,
      height: Math.round(maxDimensionSize / aspectRatio),
      didDownscale: true,
    }
  }

  return {
    width: Math.round(maxDimensionSize * aspectRatio),
    height: maxDimensionSize,
    didDownscale: true,
  }
}
